RivalIQ.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.Role = Backbone.Model.extend({
        can: function (actor, action, resource) {
            const me = this;

            let type = resource;
            if (_.isObject(resource)) {
                type = resource.type;
            }

            const permissions = _.filter(me.get('permissions'), {
                type: type
            });

            if (!permissions.length) {
                return false;
            }

            return Boolean(permissions.reduce(function (valid, permission) {
                if (!_.isUndefined(valid)) {
                    return valid;
                }

                if (RivalIQ.enums.roleAction(permission.action, action)) {
                    if (!permission.conditions) {
                        return true;
                    }

                    return permission.conditions(actor.toJSON(), resource.toJSON());
                }

                return valid;
            }, undefined));
        },

        /*
         * Returns true if the given field is editable by this role on the
         * given resource
         */
        field: function (actor, resource, field) {
            const me = this;

            let type = resource;
            if (_.isObject(resource)) {
                type = resource.type;
            }

            const rules = _.filter(me.get('fields').concat(RivalIQ.enums.roles.default.fields), {
                type: type
            });

            return _.reduce(rules, function (can, rule) {
                if (_.includes(rule.field, field)) {
                    if (rule.conditions) {
                        return rule.conditions(actor.toJSON(), resource.toJSON());
                    }
                    return true;
                }

                return can;
            }, false);
        }
    });

    models.Role.findById = function (id) {
        return new models.Role(_.find(RivalIQ.enums.roles, {
            id: id
        }));
    };
});
